import { STATE } from '../constants/stateClasses';
import { breakpoints } from '../utils/breakpoints';
import { scroll } from './locomotive';

const selectors = {
  section: ' .js-sticky-section',
  desc: '.js-sticky-desc',
  icon: '.js-sticky-icon',
  pin: '.js-sticky-pin',
  header: '.js-header',
  socials: '.js-floating-socials',
  progress: '.js-sticky-progress',
};

const classNames = {
  scrolled: 'l-header--scrolled',
};

const DIRECTION = {
  down: 'down',
};

const handleStickySection = () => {
  const section = document.querySelector(selectors.section);

  if (!section) return;

  const header = document.querySelector(selectors.header);
  const socials = document.querySelector(selectors.socials);

  const progressElem = document.querySelector(selectors.progress);
  const descElems = document.querySelectorAll(selectors.desc);
  const iconElems = document.querySelectorAll(selectors.icon);
  const pinElems = document.querySelectorAll(selectors.pin);

  const circumference = progressElem.getTotalLength();

  progressElem.style.strokeDashoffset = `${circumference}px`;
  progressElem.style.strokeDasharray = `${circumference}px`;

  const changeSlide = ({ prevIndex, curIndex, direction }) => {
    descElems[prevIndex]?.classList.remove(STATE.active);
    descElems[curIndex]?.classList.add(STATE.active);

    iconElems[prevIndex]?.classList.remove(STATE.active);
    iconElems[curIndex]?.classList.add(STATE.active);

    if (direction === DIRECTION.down) {
      pinElems[curIndex]?.classList.add(STATE.active);
    } else {
      pinElems[prevIndex]?.classList.remove(STATE.active);
    }
  };

  let prevIndex = 0;
  let curIndex;

  scroll.on('scroll', (args) => {
    const stickySection = args.currentElements['sticky-section'];

    if (!stickySection) return;

    // Prevent showing header while scrolling up
    if (breakpoints.tablet < window.innerWidth) {
      header.classList.add(classNames.scrolled);
    } else {
      socials.classList.remove(STATE.active);
    }

    const { direction } = args;
    const { progress, el } = stickySection;

    const count = Number(el.dataset.count);
    const pieceCircumference = (1 / count) * circumference;
    curIndex = Math.floor((progress * 100) / ((1 / count) * 100));

    // Inital move on start progress
    if (progress < 0.1) {
      progressElem.style.strokeDashoffset = `${direction === DIRECTION.down ? circumference - pieceCircumference : circumference}px`;

      pinElems[0]?.classList.toggle(STATE.active, direction === DIRECTION.down);
    }

    if (curIndex !== prevIndex && curIndex < descElems.length) {
      //debounced and prevent to hide last item on animatation end
      progressElem.style.strokeDashoffset = `${circumference - pieceCircumference * (curIndex + 1)}px`;

      changeSlide({ prevIndex, curIndex, direction });
      prevIndex = curIndex;
    }
  });
};

export default handleStickySection;
